'use client';

import { useTranslations } from 'next-intl';
import { MediaWithWatermark } from '@/app/components/shared/MediaWithWatermark';
import { SITE } from '@/app/constants';
import type { ProjectDetailType } from '@/app/types';
import { reportEvent } from '@/app/utils';

interface ProjectCardProps {
  project: ProjectDetailType;
  onClick: (projectId: string) => void;
  index: number;
}

const BG_LIST =
  SITE === 'china'
    ? [
        'https://image01-aliyun.vidu.zone/vidu/media-asset/project-bg-01-e26575a6.webp',
        'https://image01-aliyun.vidu.zone/vidu/media-asset/project-bg-02-a0cbcac7.webp',
        'https://image01-aliyun.vidu.zone/vidu/media-asset/project-bg-03-b8e24ec2.webp',
      ]
    : [
        'https://image01.cf.vidu.studio/vidu/media-asset/project-bg-01-e26575a6.webp',
        'https://image01.cf.vidu.studio/vidu/media-asset/project-bg-02-a0cbcac7.webp',
        'https://image01.cf.vidu.studio/vidu/media-asset/project-bg-03-b8e24ec2.webp',
      ];
// 项目卡片组件
export const ProjectCard = ({ project, onClick, index }: ProjectCardProps) => {
  const t = useTranslations();
  const handleClick = () => {
    onClick(project.id || '');
    reportEvent('project_click', {
      project_id: project.id || '',
      project_type: project.type === 'demo' ? 'sample' : 'normal',
    });
  };
  return (
    <div
      onClick={handleClick}
      className="group relative h-[136px] w-60 cursor-pointer overflow-hidden rounded-2xl bg-center bg-cover bg-no-repeat transition-all hover:scale-105"
      style={{
        backgroundImage: `url(${project.cover_url || BG_LIST[(index + 1) % BG_LIST.length]})`,
      }}
    >
      {/* 标签 */}
      {project.type === 'demo' ? (
        <div className="absolute top-2 left-2 z-10 rounded-md bg-system-black04 px-2 py-1 text-[10px] text-white leading-[14px]">
          {t('agentProject.demo')}
        </div>
      ) : project.type === 'free' ? (
        <div className="absolute top-2 left-2 z-10 rounded-md bg-blue-500 px-2 py-1 text-[10px] text-white leading-[14px]">
          {t('agentProject.freeProjectTag')}
        </div>
      ) : null}

      {/* 渐变遮罩和标题 */}
      <div
        className="absolute right-0 bottom-0 left-0 z-10 truncate p-3 text-white text-xs"
        style={{
          background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.64) 0%, rgba(0, 0, 0, 0.00) 100%)',
        }}
      >
        {project.name}
      </div>
      {SITE === 'china' && <MediaWithWatermark overlay width={16} height={9} showWatermark />}
    </div>
  );
};
